import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteTemplateRoutingModule } from './note-template-routing.module';
import { NoteTemplateComponent } from './note-template-component/note-template.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NoteTemplateService } from 'app/core/services/note-template.service';
import { DirectivesModule } from 'app/directives/directives.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';


@NgModule({
  imports: [
    AgGridModule.withComponents([BooleanCheckComponent]),
    GridComponentsModule,
    CommonModule,
    FormsModule,
    DirectivesModule,
    ReactiveFormsModule,
    Trip2ThemeModule,
    NoteTemplateRoutingModule
  ],
  declarations: [NoteTemplateComponent],
  providers: [NoteTemplateService]
})
export class NoteTemplateModule { }



// WEBPACK FOOTER //
// ./src/app/pages/note-template/note-template.module.ts